import { IonList } from "@ionic/react";
import { IonInfiniteScroll, IonInfiniteScrollContent } from "@ionic/react";
import BotListItem from "../components/BotListItem";
import { useEffect, useState } from "react";
import { subscribeToBot, useBotsStore } from "../stores/bots.store";
import { useLobbiesStore } from "../stores/lobbies.store";
import { useAuthStore } from "../stores/auth.store";
import { useUsersStore } from "../stores/users.store";

interface BotListProps {
  lobbyId?: string;
  filter?: string;
  mode?: string;
}

const BotListComponent: React.FC<BotListProps> = ({
  lobbyId,
  filter,
  mode
}) => {
  const [disableInfiniteScroll, setDisableInfiniteScroll] =
    useState<boolean>(false);
  const filterLogic: any = {
    active: (b: any) => b.active,
    upcoming: (b: any) => !b.provisioned && !b.active && !b?.payOut,
    past: (b: any) => b.provisioned && !b.active
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [instanceNumber, setInstanceNumber] = useState<number>(
    Math.floor(Math.random() * 1000000000)
  );

  const lobby = useLobbiesStore(state =>
    state.lobbies.find(l => l.id === lobbyId)
  );
  const userUids = lobby?.participants;
  const { subscribeToUser } = useUsersStore();

  useEffect(() => {
    if (userUids) {
      const unsubscribeFunctions = userUids.map((uid: string) =>
        subscribeToUser(uid)
      );

      return () => {
        unsubscribeFunctions.forEach((unsubscribe: any) => unsubscribe());
      };
    }
  }, [subscribeToUser, userUids]);

  const [displayCount, setDisplayCount] = useState<number>(
    lobby?.bots?.length || 20
  );
  const uid = useAuthStore(state => state.user?.uid);

  const bots = useBotsStore(state => {
    if (lobby?.bots && lobby?.bots.length > 0) {
      return state.bots.filter(b => lobby?.bots.includes(b.id));
    }

    return state.bots.filter(
      (b: any) =>
        b.user === uid && b.mode === mode && filter && filterLogic[filter](b)
    );
  });

  const orderedBots = bots.sort((a, b) => b.profit - a.profit);

  async function searchNext($event: CustomEvent<void>) {
    const filteredBots = orderedBots.slice(0, displayCount);
    if (filteredBots.length < bots.length) {
      // Get from 0 to filteredBots.length + 20
      setDisplayCount(filteredBots.length + 20);
      // If there are no more bots to load, disable the infinite scroll
      if (filteredBots.length >= bots.length) {
        setDisableInfiniteScroll(true);
      }
    } else {
      setDisableInfiniteScroll(true);
    }

    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  useEffect(() => {
    let unsubscribes: any[] = [];
    if (lobby && lobby?.bots?.length > 0) {
      unsubscribes = lobby?.bots.map((botId: any) => subscribeToBot(botId));
    }
    return () => {
      unsubscribes.forEach((unsubscribe: any) => unsubscribe());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-lg mx-auto">
      <div className="bg-primary-90 p-2">
        <div className="flex ml-auto pr-8 w-min gap-x-4">
          {["Trades", "Streak", "Profit", "Earnings"].map(key => (
            <div key={key} className="text-[10px] text-primary-40 uppercase">
              {key}
            </div>
          ))}
        </div>
      </div>
      <IonList className="ion-no-padding">
        {orderedBots?.slice(0, displayCount)?.map((bot, index) => (
          <BotListItem
            bot={bot}
            index={index}
            key={`${bot.id}-${instanceNumber}`}
            // classes={index % 2 === 0 ? "bg-primary-90" : "bg-primary-80"}
          />
        ))}
        <IonInfiniteScroll
          threshold="100px"
          disabled={disableInfiniteScroll}
          onIonInfinite={searchNext}
          className="bg-primary-90 text-white"
        >
          <IonInfiniteScrollContent loadingText="Loading more bots..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
      </IonList>
    </div>
  );
};

export default BotListComponent;
